export const GAME_MECHANICS = [{
  id: 1,
  name: 'memory',
  folderName: 'memory',
  isHidden: false,
  size: 2000,
}, {
  id: 2,
  name: 'itemCatcher',
  folderName: 'itemCatcher',
  isHidden: false,
  size: 2000,
}, {
  id: 3,
  name: 'slidePuzzle',
  folderName: 'slidePuzzle',
  isHidden: true,
  size: 2000,
}];

export const GAMES = [];
